import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { parse, toString } from 'Lib/Object/Path/shared';
import { dropLast } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';
import { PortionMaterialSizeDescriptionField } from '../../../../Components';

let PortionSievingDetailsSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isWashed = useSelector(createWorksheetSelector!('Washing.IsWashed'));

  const isCoarseSievingRepresentingWholePortion = namePrefix!.endsWith('WholePortion.Separation.CoarsePortion');

  const isWholePortionInitiallyWet = useSelector(
    pipe(
      createWorksheetSelector!(
        `${namePrefix!.substring(
          0,
          namePrefix!.indexOf('.WholePortion.') + '.WholePortion.'.length
        )}Preparation.StateAfterInitialPreparation`,
        false
      ),
      (s: StateOfMaterial) => s !== StateOfMaterial.OvenDry
    )
  );

  const isCoarseSievingRepresentingSeparatedPortion = namePrefix!.endsWith(
    'FinePortion.Subspecimen.Separation.CoarsePortion'
  );

  const isFineSieving = namePrefix!.endsWith('FinePortion.Subspecimen');

  const showCorrectionFactor = isFineSieving || isCoarseSievingRepresentingSeparatedPortion;

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      {isCoarseSievingRepresentingWholePortion && (
        <NamePrefixModifier namePrefix={toString(dropLast(2, parse(namePrefix!)))}>
          <Field
            input={<TextOutput />}
            label="Specimen Total Wet Mass"
            name="Masses.WetMass"
            visible={isWholePortionInitiallyWet}
          />
          <Field input={<TextOutput />} label="Specimen Total Dry Mass" name="Masses.DryMass" />
        </NamePrefixModifier>
      )}
      {isCoarseSievingRepresentingSeparatedPortion && (
        <NamePrefixModifier namePrefix={toString(dropLast(2, parse(namePrefix!)))}>
          <Field input={<TextOutput />} label="Subspecimen Total Dry Mass" name="Masses.DryMass" />
        </NamePrefixModifier>
      )}
      <Field input={<TextOutput />} label="Sieve Portion Material Dry Mass" name="Masses.DryMass" />
      <Field
        input={<TextOutput />}
        label="Sieve Portion Washed Material Dry Mass"
        name="Washing.WashedDryMass"
        visible={!!isWashed}
      />
      <Field
        input={<TextOutput />}
        label="Correction Factor"
        name="Sieving.CorrectionFactor"
        visible={!!showCorrectionFactor}
      />
      <Field
        input={<TextOutput />}
        label="Fractional Mass Retained on First Sieve (%)"
        name="Sieving.FractionalPercentRetainedOnUpperLimitSieve"
        visible={!!showCorrectionFactor}
      />
    </ListFieldSection>
  );
};
PortionSievingDetailsSection = withInjectedProps(PortionSievingDetailsSection);

export { PortionSievingDetailsSection };
export default PortionSievingDetailsSection;
